import whichEnv from '@ally/which-env'

export const CATCH_ALL_ERROR_MESSAGE = `We can't complete your request right now. Try again later.`

export const env = whichEnv(window.location.href)

export const apigeeAPIKey = env.pick({
  dev: 'wU5VdAI4fv7jgsaAOJDREixc3MOaUs1R',
  cap: '7ZJ3GWuthDWEtZTJMbopIAHtctYdW4rT',
  fix: '7ZJ3GWuthDWEtZTJMbopIAHtctYdW4rT',
  qa1: 'A2t4hfS8ULZk5AQfdtVfQwkqi0tz9OHf',
  qa2: 'A2t4hfS8ULZk5AQfdtVfQwkqi0tz9OHf',
  qa3: 'A2t4hfS8ULZk5AQfdtVfQwkqi0tz9OHf',
  prod: 'XhnbsDYmBensf2vqVXAfv0uD7SJBA27u',
  local: 'wU5VdAI4fv7jgsaAOJDREixc3MOaUs1R',
})

export const HEADERS = {
  'API-KEY': apigeeAPIKey,
}
